var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 18",
    style: {
      enableBackground: "new 0 0 21 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#888888;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    transform: "translate(-1002 -319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone_1",
    transform: "translate(1002 319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone_1_Background_Mask_",
    className: "st0",
    d: "M-1.2-2.5h23v23h-23V-2.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x32_7_Phone",
    transform: "translate(3.482 3.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M11.7,7.7c-0.8-0.6-1.9-0.4-2.5,0.4L8.7,8.9c-1-0.7-2-1.5-2.9-2.4C4.9,5.6,4.1,4.6,3.4,3.6 l0.8-0.5c0.8-0.6,1-1.7,0.4-2.5c0,0,0,0,0,0L3-1.8C2.6-2.2,2.1-2.5,1.5-2.5c-0.2,0-0.4,0-0.6,0.1C0.7-2.4,0.5-2.3,0.3-2.1L0-1.9 c-0.1,0.1-0.2,0.1-0.2,0.2c-0.4,0.4-0.7,0.9-0.8,1.5c-0.7,2.5,1,6.3,4.1,9.5c2.6,2.6,5.8,4.3,8.3,4.3l0,0c0.4,0,0.8,0,1.2-0.1 c0.6-0.1,1.1-0.4,1.5-0.8c0.1-0.1,0.1-0.2,0.2-0.2l0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.3-0.8,0-1.6-0.7-2.1l0,0L11.7,7.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.068124dcddf030dce4f26454e03f7577.svg";
export { ForwardRef as ReactComponent };